const LANDING_SECTION_HEADING_CLASS =
  'font-display text-[clamp(2rem,7vw,3.5rem)] font-extrabold tracking-tight leading-[0.95] text-stone-900 dark:text-white';

const LANDING_SECTION_HEADING_ON_DARK_CLASS =
  'font-display text-[clamp(2rem,7vw,3.5rem)] font-extrabold tracking-tight leading-[0.95] text-white';

const LANDING_SECTION_ACCENT_CLASS = 'block text-primary-500';

const LANDING_SECTION_SUBTITLE_CLASS =
  'mt-3 sm:mt-4 text-base sm:text-lg max-w-2xl leading-relaxed';

const LANDING_SECTION_SUBTITLE_DEFAULT_CLASS = `${LANDING_SECTION_SUBTITLE_CLASS} text-stone-600 dark:text-[var(--text-secondary)]`;

const LANDING_SECTION_SUBTITLE_ON_DARK_CLASS = `${LANDING_SECTION_SUBTITLE_CLASS} text-[var(--text-secondary)]`;

export function landingSectionHeadingLabel(lead, accent) {
  const parts = [lead, accent].filter(
    (part) => typeof part === 'string' && part.trim(),
  );
  return parts.join(' ').replace(/\s+/g, ' ').trim();
}

export function LandingSectionHeading({
  as = 'h2',
  align = 'center',
  eyebrow,
  lead,
  accent,
  subtitle,
  id,
  onDark = false,
  ariaLabel,
}) {
  const isPageTitle = as === 'h1';
  const HeadingTag = isPageTitle ? 'h1' : 'h2';
  const isStart = align === 'start';
  const accentText = typeof accent === 'string' ? accent.trim() : '';
  const label = ariaLabel ?? landingSectionHeadingLabel(lead, accentText);
  const subtitleClass = onDark
    ? LANDING_SECTION_SUBTITLE_ON_DARK_CLASS
    : LANDING_SECTION_SUBTITLE_DEFAULT_CLASS;
  const showEyebrow = !isPageTitle && eyebrow;
  const showSubtitle = !isPageTitle && subtitle;
  return (
    <div className={isStart ? 'text-left' : 'text-center'}>
      {showEyebrow ? (
        <p className={`instrument-page-eyebrow !mb-2 ${isStart ? 'text-left' : ''}`}>
          {eyebrow}
        </p>
      ) : null}
      <HeadingTag
        id={id}
        aria-label={label}
        className={onDark ? LANDING_SECTION_HEADING_ON_DARK_CLASS : LANDING_SECTION_HEADING_CLASS}
      >
        <span className="block">{lead}</span>
        {accentText ? (
          <span className={LANDING_SECTION_ACCENT_CLASS}>{accentText}</span>
        ) : null}
      </HeadingTag>
      {showSubtitle ? (
        <p className={`${subtitleClass} ${isStart ? 'mx-0' : 'mx-auto'}`}>
          {subtitle}
        </p>
      ) : null}
    </div>
  );
}
